export default __webpack_public_path__ + "static/media/801.9b0d9e8a.gif";